export const errori_rentri = [
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "mUBmXHkP6V-ZjT5Szs-aasdasd-sdqersc-xv21eds",
        "operatore": "simone.trandafir@nica.it",
        "dataOraOperazione": "2024-01-27 01:39:22",
        "aziendaLavoro": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt",
        "annoGestione": "Anno 2024",
        "progressivo": "000001",
        "registroRentri": "5DEGVG44",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "5iPbQ0rYaAGZHyu9",
        "operatore": "Sara Gialli",
        "dataOraOperazione": "2022-09-11 19:46:55",
        "aziendaLavoro": "Leonardo",
        "annoGestione": 2023,
        "progressivo": "000001",
        "registroRentri": "PSTI5JJJ",
        "errorTextFull": "Permesso negato (dettagli: hWBktNrlQ1CS2nYv3OM0)"
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "jW7JX1sgt2sZDFwQ",
        "operatore": "Luigi Verdi",
        "dataOraOperazione": "2023-05-02 10:14:23",
        "aziendaLavoro": "Enel",
        "annoGestione": 2021,
        "progressivo": "000001",
        "registroRentri": "U12YLA7X",
        "errorTextFull": "Connessione persa (dettagli: 2rEaW9VZqsDfRthp5SYX)"
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "pYrfnzj7HQZC5VxD",
        "operatore": "Mario Rossi",
        "dataOraOperazione": "2024-03-09 16:12:47",
        "aziendaLavoro": "Ferrari",
        "annoGestione": 2025,
        "progressivo": "000001",
        "registroRentri": "2M6XDAPG",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "NkIv7Ce3pTbP0AxY",
        "operatore": "Giovanni Blu",
        "dataOraOperazione": "2024-06-02 04:55:51",
        "aziendaLavoro": "Barilla",
        "annoGestione": 2022,
        "progressivo": "000001",
        "registroRentri": "0HQ8BFC7",
        "errorTextFull": "Dati corrotti (dettagli: uTBGNIPakL0j8XyDvz4q)"
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "2IHvAqQf0XSnC7bF",
        "operatore": "Elena Neri",
        "dataOraOperazione": "2023-12-16 11:20:08",
        "aziendaLavoro": "Eni",
        "annoGestione": 2022,
        "progressivo": "000001",
        "registroRentri": "GLRS0URK",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "tBNSC82LoUevfXkJ",
        "operatore": "Carla Bianchi",
        "dataOraOperazione": "2024-11-01 20:04:19",
        "aziendaLavoro": "Barilla",
        "annoGestione": 2023,
        "progressivo": "000001",
        "registroRentri": "2QQF7X0Z",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "bghh2s7Z1hN9lfuT",
        "operatore": "Giovanni Blu",
        "dataOraOperazione": "2024-05-15 17:52:01",
        "aziendaLavoro": "Telecom",
        "annoGestione": 2022,
        "progressivo": "000001",
        "registroRentri": "JCKLVE5N",
        "errorTextFull": "Record non trovato (dettagli: FCyN9Uo8tQjBp2z31ZE6)"
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "Q1YiMsxd2WZ5ofCr",
        "operatore": "Luigi Verdi",
        "dataOraOperazione": "2022-04-21 06:39:00",
        "aziendaLavoro": "Luxottica",
        "annoGestione": 2025,
        "progressivo": "000001",
        "registroRentri": "B4UO1M7S",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "AKFvOaQ0TjPvRynE",
        "operatore": "Sara Gialli",
        "dataOraOperazione": "2025-06-13 13:32:36",
        "aziendaLavoro": "Ferrari",
        "annoGestione": 2024,
        "progressivo": "000001",
        "registroRentri": "XQ4D1IFP",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "eZTvgYujHk6ApbIw",
        "operatore": "Davide Marrone",
        "dataOraOperazione": "2023-08-10 14:19:48",
        "aziendaLavoro": "Eni",
        "annoGestione": 2023,
        "progressivo": "000001",
        "registroRentri": "AVKU09TG",
        "errorTextFull": "Timeout (dettagli: k8GMnH0CbqVXxSZtBPoT)"
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "Fd53btMoyN6ZIxuh",
        "operatore": "Elena Neri",
        "dataOraOperazione": "2022-03-19 22:11:16",
        "aziendaLavoro": "Leonardo",
        "annoGestione": 2022,
        "progressivo": "000001",
        "registroRentri": "6BP3QX2E",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "A0YvXcSpj4Tew2U3",
        "operatore": "Mario Rossi",
        "dataOraOperazione": "2022-07-24 18:23:33",
        "aziendaLavoro": "Telecom",
        "annoGestione": 2021,
        "progressivo": "000001",
        "registroRentri": "P1L7NGZT",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "x0X6p7wa9tGhbZVq",
        "operatore": "Carla Bianchi",
        "dataOraOperazione": "2023-01-12 23:03:02",
        "aziendaLavoro": "Barilla",
        "annoGestione": 2021,
        "progressivo": "000001",
        "registroRentri": "S2BQ8UVC",
        "errorTextFull": "Connessione persa (dettagli: W8lKQwCNPvmijD1c4eEY)"
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "X2EymB0IzUuS6k5J",
        "operatore": "Giovanni Blu",
        "dataOraOperazione": "2025-05-24 05:36:42",
        "aziendaLavoro": "Eni",
        "annoGestione": 2025,
        "progressivo": "000001",
        "registroRentri": "9RU7TQK3",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "rGhXW3y1t9ZMo4cR",
        "operatore": "Elena Neri",
        "dataOraOperazione": "2023-11-03 08:55:05",
        "aziendaLavoro": "Luxottica",
        "annoGestione": 2023,
        "progressivo": "000001",
        "registroRentri": "TGD51F2W",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "xOzF2j5AI8eUbkGs",
        "operatore": "Sara Gialli",
        "dataOraOperazione": "2023-09-25 12:00:13",
        "aziendaLavoro": "Ferrari",
        "annoGestione": 2022,
        "progressivo": "000001",
        "registroRentri": "5U6S8VZW",
        "errorTextFull": "Permesso negato (dettagli: KD9F3tc4VRpWwQqOXYnJ)"
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "l9Axu2bDJ5Gq1fZK",
        "operatore": "Davide Marrone",
        "dataOraOperazione": "2024-08-21 17:33:57",
        "aziendaLavoro": "Telecom",
        "annoGestione": 2021,
        "progressivo": "000001",
        "registroRentri": "IZG7L0WB",
        "errorTextFull": "Timeout (dettagli: nNoSgPajkJrcuT3KQiv6)"
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "pKfbS1aW0VdLbE7y",
        "operatore": "Carla Bianchi",
        "dataOraOperazione": "2022-12-04 14:41:10",
        "aziendaLavoro": "Leonardo",
        "annoGestione": 2023,
        "progressivo": "000001",
        "registroRentri": "C1ZX67UP",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "B3LjQv6ZHcNSKYl5",
        "operatore": "Luigi Verdi",
        "dataOraOperazione": "2024-04-03 21:00:56",
        "aziendaLavoro": "Enel",
        "annoGestione": 2022,
        "progressivo": "000001",
        "registroRentri": "D2H5W8TJ",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "M0FZX5URv8y12hQz",
        "operatore": "Mario Rossi",
        "dataOraOperazione": "2025-03-14 19:45:11",
        "aziendaLavoro": "Eni",
        "annoGestione": 2024,
        "progressivo": "000001",
        "registroRentri": "0T3A5PFS",
        "errorTextFull": "Dati corrotti (dettagli: 1d8XVJtWcQ7GFN6o3hpz)"
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "mUBmXHkP6V-ZjT5Szs-aasdasd-sdqersc-xv21eds",
        "operatore": "simone.trandafir@nica.it",
        "dataOraOperazione": "2024-01-27 01:39:22",
        "aziendaLavoro": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt",
        "annoGestione": "Anno 2024",
        "progressivo": "000001",
        "registroRentri": "5DEGVG44",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "5iPbQ0rYaAGZHyu9",
        "operatore": "Sara Gialli",
        "dataOraOperazione": "2022-09-11 19:46:55",
        "aziendaLavoro": "Leonardo",
        "annoGestione": 2023,
        "progressivo": "000001",
        "registroRentri": "PSTI5JJJ",
        "errorTextFull": "Permesso negato (dettagli: hWBktNrlQ1CS2nYv3OM0)"
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "jW7JX1sgt2sZDFwQ",
        "operatore": "Luigi Verdi",
        "dataOraOperazione": "2023-05-02 10:14:23",
        "aziendaLavoro": "Enel",
        "annoGestione": 2021,
        "progressivo": "000001",
        "registroRentri": "U12YLA7X",
        "errorTextFull": "Connessione persa (dettagli: 2rEaW9VZqsDfRthp5SYX)"
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "pYrfnzj7HQZC5VxD",
        "operatore": "Mario Rossi",
        "dataOraOperazione": "2024-03-09 16:12:47",
        "aziendaLavoro": "Ferrari",
        "annoGestione": 2025,
        "progressivo": "000001",
        "registroRentri": "2M6XDAPG",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "NkIv7Ce3pTbP0AxY",
        "operatore": "Giovanni Blu",
        "dataOraOperazione": "2024-06-02 04:55:51",
        "aziendaLavoro": "Barilla",
        "annoGestione": 2022,
        "progressivo": "000001",
        "registroRentri": "0HQ8BFC7",
        "errorTextFull": "Dati corrotti (dettagli: uTBGNIPakL0j8XyDvz4q)"
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "2IHvAqQf0XSnC7bF",
        "operatore": "Elena Neri",
        "dataOraOperazione": "2023-12-16 11:20:08",
        "aziendaLavoro": "Eni",
        "annoGestione": 2022,
        "progressivo": "000001",
        "registroRentri": "GLRS0URK",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "tBNSC82LoUevfXkJ",
        "operatore": "Carla Bianchi",
        "dataOraOperazione": "2024-11-01 20:04:19",
        "aziendaLavoro": "Barilla",
        "annoGestione": 2023,
        "progressivo": "000001",
        "registroRentri": "2QQF7X0Z",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "bghh2s7Z1hN9lfuT",
        "operatore": "Giovanni Blu",
        "dataOraOperazione": "2024-05-15 17:52:01",
        "aziendaLavoro": "Telecom",
        "annoGestione": 2022,
        "progressivo": "000001",
        "registroRentri": "JCKLVE5N",
        "errorTextFull": "Record non trovato (dettagli: FCyN9Uo8tQjBp2z31ZE6)"
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "Q1YiMsxd2WZ5ofCr",
        "operatore": "Luigi Verdi",
        "dataOraOperazione": "2022-04-21 06:39:00",
        "aziendaLavoro": "Luxottica",
        "annoGestione": 2025,
        "progressivo": "000001",
        "registroRentri": "B4UO1M7S",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "AKFvOaQ0TjPvRynE",
        "operatore": "Sara Gialli",
        "dataOraOperazione": "2025-06-13 13:32:36",
        "aziendaLavoro": "Ferrari",
        "annoGestione": 2024,
        "progressivo": "000001",
        "registroRentri": "XQ4D1IFP",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "eZTvgYujHk6ApbIw",
        "operatore": "Davide Marrone",
        "dataOraOperazione": "2023-08-10 14:19:48",
        "aziendaLavoro": "Eni",
        "annoGestione": 2023,
        "progressivo": "000001",
        "registroRentri": "AVKU09TG",
        "errorTextFull": "Timeout (dettagli: k8GMnH0CbqVXxSZtBPoT)"
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "Fd53btMoyN6ZIxuh",
        "operatore": "Elena Neri",
        "dataOraOperazione": "2022-03-19 22:11:16",
        "aziendaLavoro": "Leonardo",
        "annoGestione": 2022,
        "progressivo": "000001",
        "registroRentri": "6BP3QX2E",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "A0YvXcSpj4Tew2U3",
        "operatore": "Mario Rossi",
        "dataOraOperazione": "2022-07-24 18:23:33",
        "aziendaLavoro": "Telecom",
        "annoGestione": 2021,
        "progressivo": "000001",
        "registroRentri": "P1L7NGZT",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "x0X6p7wa9tGhbZVq",
        "operatore": "Carla Bianchi",
        "dataOraOperazione": "2023-01-12 23:03:02",
        "aziendaLavoro": "Barilla",
        "annoGestione": 2021,
        "progressivo": "000001",
        "registroRentri": "S2BQ8UVC",
        "errorTextFull": "Connessione persa (dettagli: W8lKQwCNPvmijD1c4eEY)"
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "X2EymB0IzUuS6k5J",
        "operatore": "Giovanni Blu",
        "dataOraOperazione": "2025-05-24 05:36:42",
        "aziendaLavoro": "Eni",
        "annoGestione": 2025,
        "progressivo": "000001",
        "registroRentri": "9RU7TQK3",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "rGhXW3y1t9ZMo4cR",
        "operatore": "Elena Neri",
        "dataOraOperazione": "2023-11-03 08:55:05",
        "aziendaLavoro": "Luxottica",
        "annoGestione": 2023,
        "progressivo": "000001",
        "registroRentri": "TGD51F2W",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "xOzF2j5AI8eUbkGs",
        "operatore": "Sara Gialli",
        "dataOraOperazione": "2023-09-25 12:00:13",
        "aziendaLavoro": "Ferrari",
        "annoGestione": 2022,
        "progressivo": "000001",
        "registroRentri": "5U6S8VZW",
        "errorTextFull": "Permesso negato (dettagli: KD9F3tc4VRpWwQqOXYnJ)"
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "l9Axu2bDJ5Gq1fZK",
        "operatore": "Davide Marrone",
        "dataOraOperazione": "2024-08-21 17:33:57",
        "aziendaLavoro": "Telecom",
        "annoGestione": 2021,
        "progressivo": "000001",
        "registroRentri": "IZG7L0WB",
        "errorTextFull": "Timeout (dettagli: nNoSgPajkJrcuT3KQiv6)"
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "pKfbS1aW0VdLbE7y",
        "operatore": "Carla Bianchi",
        "dataOraOperazione": "2022-12-04 14:41:10",
        "aziendaLavoro": "Leonardo",
        "annoGestione": 2023,
        "progressivo": "000001",
        "registroRentri": "C1ZX67UP",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "B3LjQv6ZHcNSKYl5",
        "operatore": "Luigi Verdi",
        "dataOraOperazione": "2024-04-03 21:00:56",
        "aziendaLavoro": "Enel",
        "annoGestione": 2022,
        "progressivo": "000001",
        "registroRentri": "D2H5W8TJ",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "M0FZX5URv8y12hQz",
        "operatore": "Mario Rossi",
        "dataOraOperazione": "2025-03-14 19:45:11",
        "aziendaLavoro": "Eni",
        "annoGestione": 2024,
        "progressivo": "000001",
        "registroRentri": "0T3A5PFS",
        "errorTextFull": "Dati corrotti (dettagli: 1d8XVJtWcQ7GFN6o3hpz)"
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "mUBmXHkP6V-ZjT5Szs-aasdasd-sdqersc-xv21eds",
        "operatore": "simone.trandafir@nica.it",
        "dataOraOperazione": "2024-01-27 01:39:22",
        "aziendaLavoro": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt",
        "annoGestione": "Anno 2024",
        "progressivo": "000001",
        "registroRentri": "5DEGVG44",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "5iPbQ0rYaAGZHyu9",
        "operatore": "Sara Gialli",
        "dataOraOperazione": "2022-09-11 19:46:55",
        "aziendaLavoro": "Leonardo",
        "annoGestione": 2023,
        "progressivo": "000001",
        "registroRentri": "PSTI5JJJ",
        "errorTextFull": "Permesso negato (dettagli: hWBktNrlQ1CS2nYv3OM0)"
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "jW7JX1sgt2sZDFwQ",
        "operatore": "Luigi Verdi",
        "dataOraOperazione": "2023-05-02 10:14:23",
        "aziendaLavoro": "Enel",
        "annoGestione": 2021,
        "progressivo": "000001",
        "registroRentri": "U12YLA7X",
        "errorTextFull": "Connessione persa (dettagli: 2rEaW9VZqsDfRthp5SYX)"
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "pYrfnzj7HQZC5VxD",
        "operatore": "Mario Rossi",
        "dataOraOperazione": "2024-03-09 16:12:47",
        "aziendaLavoro": "Ferrari",
        "annoGestione": 2025,
        "progressivo": "000001",
        "registroRentri": "2M6XDAPG",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "NkIv7Ce3pTbP0AxY",
        "operatore": "Giovanni Blu",
        "dataOraOperazione": "2024-06-02 04:55:51",
        "aziendaLavoro": "Barilla",
        "annoGestione": 2022,
        "progressivo": "000001",
        "registroRentri": "0HQ8BFC7",
        "errorTextFull": "Dati corrotti (dettagli: uTBGNIPakL0j8XyDvz4q)"
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "2IHvAqQf0XSnC7bF",
        "operatore": "Elena Neri",
        "dataOraOperazione": "2023-12-16 11:20:08",
        "aziendaLavoro": "Eni",
        "annoGestione": 2022,
        "progressivo": "000001",
        "registroRentri": "GLRS0URK",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "tBNSC82LoUevfXkJ",
        "operatore": "Carla Bianchi",
        "dataOraOperazione": "2024-11-01 20:04:19",
        "aziendaLavoro": "Barilla",
        "annoGestione": 2023,
        "progressivo": "000001",
        "registroRentri": "2QQF7X0Z",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "bghh2s7Z1hN9lfuT",
        "operatore": "Giovanni Blu",
        "dataOraOperazione": "2024-05-15 17:52:01",
        "aziendaLavoro": "Telecom",
        "annoGestione": 2022,
        "progressivo": "000001",
        "registroRentri": "JCKLVE5N",
        "errorTextFull": "Record non trovato (dettagli: FCyN9Uo8tQjBp2z31ZE6)"
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "Q1YiMsxd2WZ5ofCr",
        "operatore": "Luigi Verdi",
        "dataOraOperazione": "2022-04-21 06:39:00",
        "aziendaLavoro": "Luxottica",
        "annoGestione": 2025,
        "progressivo": "000001",
        "registroRentri": "B4UO1M7S",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "AKFvOaQ0TjPvRynE",
        "operatore": "Sara Gialli",
        "dataOraOperazione": "2025-06-13 13:32:36",
        "aziendaLavoro": "Ferrari",
        "annoGestione": 2024,
        "progressivo": "000001",
        "registroRentri": "XQ4D1IFP",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "eZTvgYujHk6ApbIw",
        "operatore": "Davide Marrone",
        "dataOraOperazione": "2023-08-10 14:19:48",
        "aziendaLavoro": "Eni",
        "annoGestione": 2023,
        "progressivo": "000001",
        "registroRentri": "AVKU09TG",
        "errorTextFull": "Timeout (dettagli: k8GMnH0CbqVXxSZtBPoT)"
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "Fd53btMoyN6ZIxuh",
        "operatore": "Elena Neri",
        "dataOraOperazione": "2022-03-19 22:11:16",
        "aziendaLavoro": "Leonardo",
        "annoGestione": 2022,
        "progressivo": "000001",
        "registroRentri": "6BP3QX2E",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "A0YvXcSpj4Tew2U3",
        "operatore": "Mario Rossi",
        "dataOraOperazione": "2022-07-24 18:23:33",
        "aziendaLavoro": "Telecom",
        "annoGestione": 2021,
        "progressivo": "000001",
        "registroRentri": "P1L7NGZT",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "x0X6p7wa9tGhbZVq",
        "operatore": "Carla Bianchi",
        "dataOraOperazione": "2023-01-12 23:03:02",
        "aziendaLavoro": "Barilla",
        "annoGestione": 2021,
        "progressivo": "000001",
        "registroRentri": "S2BQ8UVC",
        "errorTextFull": "Connessione persa (dettagli: W8lKQwCNPvmijD1c4eEY)"
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "X2EymB0IzUuS6k5J",
        "operatore": "Giovanni Blu",
        "dataOraOperazione": "2025-05-24 05:36:42",
        "aziendaLavoro": "Eni",
        "annoGestione": 2025,
        "progressivo": "000001",
        "registroRentri": "9RU7TQK3",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "rGhXW3y1t9ZMo4cR",
        "operatore": "Elena Neri",
        "dataOraOperazione": "2023-11-03 08:55:05",
        "aziendaLavoro": "Luxottica",
        "annoGestione": 2023,
        "progressivo": "000001",
        "registroRentri": "TGD51F2W",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "xOzF2j5AI8eUbkGs",
        "operatore": "Sara Gialli",
        "dataOraOperazione": "2023-09-25 12:00:13",
        "aziendaLavoro": "Ferrari",
        "annoGestione": 2022,
        "progressivo": "000001",
        "registroRentri": "5U6S8VZW",
        "errorTextFull": "Permesso negato (dettagli: KD9F3tc4VRpWwQqOXYnJ)"
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "l9Axu2bDJ5Gq1fZK",
        "operatore": "Davide Marrone",
        "dataOraOperazione": "2024-08-21 17:33:57",
        "aziendaLavoro": "Telecom",
        "annoGestione": 2021,
        "progressivo": "000001",
        "registroRentri": "IZG7L0WB",
        "errorTextFull": "Timeout (dettagli: nNoSgPajkJrcuT3KQiv6)"
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "pKfbS1aW0VdLbE7y",
        "operatore": "Carla Bianchi",
        "dataOraOperazione": "2022-12-04 14:41:10",
        "aziendaLavoro": "Leonardo",
        "annoGestione": 2023,
        "progressivo": "000001",
        "registroRentri": "C1ZX67UP",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "B3LjQv6ZHcNSKYl5",
        "operatore": "Luigi Verdi",
        "dataOraOperazione": "2024-04-03 21:00:56",
        "aziendaLavoro": "Enel",
        "annoGestione": 2022,
        "progressivo": "000001",
        "registroRentri": "D2H5W8TJ",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "M0FZX5URv8y12hQz",
        "operatore": "Mario Rossi",
        "dataOraOperazione": "2025-03-14 19:45:11",
        "aziendaLavoro": "Eni",
        "annoGestione": 2024,
        "progressivo": "000001",
        "registroRentri": "0T3A5PFS",
        "errorTextFull": "Dati corrotti (dettagli: 1d8XVJtWcQ7GFN6o3hpz)"
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "mUBmXHkP6V-ZjT5Szs-aasdasd-sdqersc-xv21eds",
        "operatore": "simone.trandafir@nica.it",
        "dataOraOperazione": "2024-01-27 01:39:22",
        "aziendaLavoro": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt",
        "annoGestione": "Anno 2024",
        "progressivo": "000001",
        "registroRentri": "5DEGVG44",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "5iPbQ0rYaAGZHyu9",
        "operatore": "Sara Gialli",
        "dataOraOperazione": "2022-09-11 19:46:55",
        "aziendaLavoro": "Leonardo",
        "annoGestione": 2023,
        "progressivo": "000001",
        "registroRentri": "PSTI5JJJ",
        "errorTextFull": "Permesso negato (dettagli: hWBktNrlQ1CS2nYv3OM0)"
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "jW7JX1sgt2sZDFwQ",
        "operatore": "Luigi Verdi",
        "dataOraOperazione": "2023-05-02 10:14:23",
        "aziendaLavoro": "Enel",
        "annoGestione": 2021,
        "progressivo": "000001",
        "registroRentri": "U12YLA7X",
        "errorTextFull": "Connessione persa (dettagli: 2rEaW9VZqsDfRthp5SYX)"
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "pYrfnzj7HQZC5VxD",
        "operatore": "Mario Rossi",
        "dataOraOperazione": "2024-03-09 16:12:47",
        "aziendaLavoro": "Ferrari",
        "annoGestione": 2025,
        "progressivo": "000001",
        "registroRentri": "2M6XDAPG",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "NkIv7Ce3pTbP0AxY",
        "operatore": "Giovanni Blu",
        "dataOraOperazione": "2024-06-02 04:55:51",
        "aziendaLavoro": "Barilla",
        "annoGestione": 2022,
        "progressivo": "000001",
        "registroRentri": "0HQ8BFC7",
        "errorTextFull": "Dati corrotti (dettagli: uTBGNIPakL0j8XyDvz4q)"
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "2IHvAqQf0XSnC7bF",
        "operatore": "Elena Neri",
        "dataOraOperazione": "2023-12-16 11:20:08",
        "aziendaLavoro": "Eni",
        "annoGestione": 2022,
        "progressivo": "000001",
        "registroRentri": "GLRS0URK",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "tBNSC82LoUevfXkJ",
        "operatore": "Carla Bianchi",
        "dataOraOperazione": "2024-11-01 20:04:19",
        "aziendaLavoro": "Barilla",
        "annoGestione": 2023,
        "progressivo": "000001",
        "registroRentri": "2QQF7X0Z",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "bghh2s7Z1hN9lfuT",
        "operatore": "Giovanni Blu",
        "dataOraOperazione": "2024-05-15 17:52:01",
        "aziendaLavoro": "Telecom",
        "annoGestione": 2022,
        "progressivo": "000001",
        "registroRentri": "JCKLVE5N",
        "errorTextFull": "Record non trovato (dettagli: FCyN9Uo8tQjBp2z31ZE6)"
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "Q1YiMsxd2WZ5ofCr",
        "operatore": "Luigi Verdi",
        "dataOraOperazione": "2022-04-21 06:39:00",
        "aziendaLavoro": "Luxottica",
        "annoGestione": 2025,
        "progressivo": "000001",
        "registroRentri": "B4UO1M7S",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "AKFvOaQ0TjPvRynE",
        "operatore": "Sara Gialli",
        "dataOraOperazione": "2025-06-13 13:32:36",
        "aziendaLavoro": "Ferrari",
        "annoGestione": 2024,
        "progressivo": "000001",
        "registroRentri": "XQ4D1IFP",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "eZTvgYujHk6ApbIw",
        "operatore": "Davide Marrone",
        "dataOraOperazione": "2023-08-10 14:19:48",
        "aziendaLavoro": "Eni",
        "annoGestione": 2023,
        "progressivo": "000001",
        "registroRentri": "AVKU09TG",
        "errorTextFull": "Timeout (dettagli: k8GMnH0CbqVXxSZtBPoT)"
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "Fd53btMoyN6ZIxuh",
        "operatore": "Elena Neri",
        "dataOraOperazione": "2022-03-19 22:11:16",
        "aziendaLavoro": "Leonardo",
        "annoGestione": 2022,
        "progressivo": "000001",
        "registroRentri": "6BP3QX2E",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "A0YvXcSpj4Tew2U3",
        "operatore": "Mario Rossi",
        "dataOraOperazione": "2022-07-24 18:23:33",
        "aziendaLavoro": "Telecom",
        "annoGestione": 2021,
        "progressivo": "000001",
        "registroRentri": "P1L7NGZT",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "x0X6p7wa9tGhbZVq",
        "operatore": "Carla Bianchi",
        "dataOraOperazione": "2023-01-12 23:03:02",
        "aziendaLavoro": "Barilla",
        "annoGestione": 2021,
        "progressivo": "000001",
        "registroRentri": "S2BQ8UVC",
        "errorTextFull": "Connessione persa (dettagli: W8lKQwCNPvmijD1c4eEY)"
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "X2EymB0IzUuS6k5J",
        "operatore": "Giovanni Blu",
        "dataOraOperazione": "2025-05-24 05:36:42",
        "aziendaLavoro": "Eni",
        "annoGestione": 2025,
        "progressivo": "000001",
        "registroRentri": "9RU7TQK3",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "rGhXW3y1t9ZMo4cR",
        "operatore": "Elena Neri",
        "dataOraOperazione": "2023-11-03 08:55:05",
        "aziendaLavoro": "Luxottica",
        "annoGestione": 2023,
        "progressivo": "000001",
        "registroRentri": "TGD51F2W",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "xOzF2j5AI8eUbkGs",
        "operatore": "Sara Gialli",
        "dataOraOperazione": "2023-09-25 12:00:13",
        "aziendaLavoro": "Ferrari",
        "annoGestione": 2022,
        "progressivo": "000001",
        "registroRentri": "5U6S8VZW",
        "errorTextFull": "Permesso negato (dettagli: KD9F3tc4VRpWwQqOXYnJ)"
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "l9Axu2bDJ5Gq1fZK",
        "operatore": "Davide Marrone",
        "dataOraOperazione": "2024-08-21 17:33:57",
        "aziendaLavoro": "Telecom",
        "annoGestione": 2021,
        "progressivo": "000001",
        "registroRentri": "IZG7L0WB",
        "errorTextFull": "Timeout (dettagli: nNoSgPajkJrcuT3KQiv6)"
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "pKfbS1aW0VdLbE7y",
        "operatore": "Carla Bianchi",
        "dataOraOperazione": "2022-12-04 14:41:10",
        "aziendaLavoro": "Leonardo",
        "annoGestione": 2023,
        "progressivo": "000001",
        "registroRentri": "C1ZX67UP",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "B3LjQv6ZHcNSKYl5",
        "operatore": "Luigi Verdi",
        "dataOraOperazione": "2024-04-03 21:00:56",
        "aziendaLavoro": "Enel",
        "annoGestione": 2022,
        "progressivo": "000001",
        "registroRentri": "D2H5W8TJ",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "M0FZX5URv8y12hQz",
        "operatore": "Mario Rossi",
        "dataOraOperazione": "2025-03-14 19:45:11",
        "aziendaLavoro": "Eni",
        "annoGestione": 2024,
        "progressivo": "000001",
        "registroRentri": "0T3A5PFS",
        "errorTextFull": "Dati corrotti (dettagli: 1d8XVJtWcQ7GFN6o3hpz)"
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "mUBmXHkP6V-ZjT5Szs-aasdasd-sdqersc-xv21eds",
        "operatore": "simone.trandafir@nica.it",
        "dataOraOperazione": "2024-01-27 01:39:22",
        "aziendaLavoro": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt",
        "annoGestione": "Anno 2024",
        "progressivo": "000001",
        "registroRentri": "5DEGVG44",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "5iPbQ0rYaAGZHyu9",
        "operatore": "Sara Gialli",
        "dataOraOperazione": "2022-09-11 19:46:55",
        "aziendaLavoro": "Leonardo",
        "annoGestione": 2023,
        "progressivo": "000001",
        "registroRentri": "PSTI5JJJ",
        "errorTextFull": "Permesso negato (dettagli: hWBktNrlQ1CS2nYv3OM0)"
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "jW7JX1sgt2sZDFwQ",
        "operatore": "Luigi Verdi",
        "dataOraOperazione": "2023-05-02 10:14:23",
        "aziendaLavoro": "Enel",
        "annoGestione": 2021,
        "progressivo": "000001",
        "registroRentri": "U12YLA7X",
        "errorTextFull": "Connessione persa (dettagli: 2rEaW9VZqsDfRthp5SYX)"
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "pYrfnzj7HQZC5VxD",
        "operatore": "Mario Rossi",
        "dataOraOperazione": "2024-03-09 16:12:47",
        "aziendaLavoro": "Ferrari",
        "annoGestione": 2025,
        "progressivo": "000001",
        "registroRentri": "2M6XDAPG",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "NkIv7Ce3pTbP0AxY",
        "operatore": "Giovanni Blu",
        "dataOraOperazione": "2024-06-02 04:55:51",
        "aziendaLavoro": "Barilla",
        "annoGestione": 2022,
        "progressivo": "000001",
        "registroRentri": "0HQ8BFC7",
        "errorTextFull": "Dati corrotti (dettagli: uTBGNIPakL0j8XyDvz4q)"
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "2IHvAqQf0XSnC7bF",
        "operatore": "Elena Neri",
        "dataOraOperazione": "2023-12-16 11:20:08",
        "aziendaLavoro": "Eni",
        "annoGestione": 2022,
        "progressivo": "000001",
        "registroRentri": "GLRS0URK",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "tBNSC82LoUevfXkJ",
        "operatore": "Carla Bianchi",
        "dataOraOperazione": "2024-11-01 20:04:19",
        "aziendaLavoro": "Barilla",
        "annoGestione": 2023,
        "progressivo": "000001",
        "registroRentri": "2QQF7X0Z",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "bghh2s7Z1hN9lfuT",
        "operatore": "Giovanni Blu",
        "dataOraOperazione": "2024-05-15 17:52:01",
        "aziendaLavoro": "Telecom",
        "annoGestione": 2022,
        "progressivo": "000001",
        "registroRentri": "JCKLVE5N",
        "errorTextFull": "Record non trovato (dettagli: FCyN9Uo8tQjBp2z31ZE6)"
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "Q1YiMsxd2WZ5ofCr",
        "operatore": "Luigi Verdi",
        "dataOraOperazione": "2022-04-21 06:39:00",
        "aziendaLavoro": "Luxottica",
        "annoGestione": 2025,
        "progressivo": "000001",
        "registroRentri": "B4UO1M7S",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "AKFvOaQ0TjPvRynE",
        "operatore": "Sara Gialli",
        "dataOraOperazione": "2025-06-13 13:32:36",
        "aziendaLavoro": "Ferrari",
        "annoGestione": 2024,
        "progressivo": "000001",
        "registroRentri": "XQ4D1IFP",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "eZTvgYujHk6ApbIw",
        "operatore": "Davide Marrone",
        "dataOraOperazione": "2023-08-10 14:19:48",
        "aziendaLavoro": "Eni",
        "annoGestione": 2023,
        "progressivo": "000001",
        "registroRentri": "AVKU09TG",
        "errorTextFull": "Timeout (dettagli: k8GMnH0CbqVXxSZtBPoT)"
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "Fd53btMoyN6ZIxuh",
        "operatore": "Elena Neri",
        "dataOraOperazione": "2022-03-19 22:11:16",
        "aziendaLavoro": "Leonardo",
        "annoGestione": 2022,
        "progressivo": "000001",
        "registroRentri": "6BP3QX2E",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "A0YvXcSpj4Tew2U3",
        "operatore": "Mario Rossi",
        "dataOraOperazione": "2022-07-24 18:23:33",
        "aziendaLavoro": "Telecom",
        "annoGestione": 2021,
        "progressivo": "000001",
        "registroRentri": "P1L7NGZT",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "x0X6p7wa9tGhbZVq",
        "operatore": "Carla Bianchi",
        "dataOraOperazione": "2023-01-12 23:03:02",
        "aziendaLavoro": "Barilla",
        "annoGestione": 2021,
        "progressivo": "000001",
        "registroRentri": "S2BQ8UVC",
        "errorTextFull": "Connessione persa (dettagli: W8lKQwCNPvmijD1c4eEY)"
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "X2EymB0IzUuS6k5J",
        "operatore": "Giovanni Blu",
        "dataOraOperazione": "2025-05-24 05:36:42",
        "aziendaLavoro": "Eni",
        "annoGestione": 2025,
        "progressivo": "000001",
        "registroRentri": "9RU7TQK3",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "rGhXW3y1t9ZMo4cR",
        "operatore": "Elena Neri",
        "dataOraOperazione": "2023-11-03 08:55:05",
        "aziendaLavoro": "Luxottica",
        "annoGestione": 2023,
        "progressivo": "000001",
        "registroRentri": "TGD51F2W",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "xOzF2j5AI8eUbkGs",
        "operatore": "Sara Gialli",
        "dataOraOperazione": "2023-09-25 12:00:13",
        "aziendaLavoro": "Ferrari",
        "annoGestione": 2022,
        "progressivo": "000001",
        "registroRentri": "5U6S8VZW",
        "errorTextFull": "Permesso negato (dettagli: KD9F3tc4VRpWwQqOXYnJ)"
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "l9Axu2bDJ5Gq1fZK",
        "operatore": "Davide Marrone",
        "dataOraOperazione": "2024-08-21 17:33:57",
        "aziendaLavoro": "Telecom",
        "annoGestione": 2021,
        "progressivo": "000001",
        "registroRentri": "IZG7L0WB",
        "errorTextFull": "Timeout (dettagli: nNoSgPajkJrcuT3KQiv6)"
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "pKfbS1aW0VdLbE7y",
        "operatore": "Carla Bianchi",
        "dataOraOperazione": "2022-12-04 14:41:10",
        "aziendaLavoro": "Leonardo",
        "annoGestione": 2023,
        "progressivo": "000001",
        "registroRentri": "C1ZX67UP",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "B3LjQv6ZHcNSKYl5",
        "operatore": "Luigi Verdi",
        "dataOraOperazione": "2024-04-03 21:00:56",
        "aziendaLavoro": "Enel",
        "annoGestione": 2022,
        "progressivo": "000001",
        "registroRentri": "D2H5W8TJ",
        "errorTextFull": ""
    },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "M0FZX5URv8y12hQz",
        "operatore": "Mario Rossi",
        "dataOraOperazione": "2025-03-14 19:45:11",
        "aziendaLavoro": "Eni",
        "annoGestione": 2024,
        "progressivo": "000001",
        "registroRentri": "0T3A5PFS",
        "errorTextFull": "Dati corrotti (dettagli: 1d8XVJtWcQ7GFN6o3hpz)"
    }
]

export const censimento = [
    // {
    //     "ragSoc": "SANPELLEGRINO SPA",
    //     "piva": "00753740158",
    //     "cf": "00753740158",
    //     "ind": "via luca giordano",
    //     "civico": "90",
    //     "frazione": "",
    //     "cap": "80040",
    //     "comune": "Cercola",
    //     "provincia": "NAPOLI",
    // },
    {
        "errorText": "Errore progressivo movimenti.movimentiDuplicatoDatabase",
        "guidTrans": "00753740158",
        "operatore": "SANPELLEGRINO SPA",
        "dataOraOperazione": "via luca giordano",
        "aziendaLavoro": "90",
        "annoGestione": 'Cercola',
        "progressivo": "NAPOLI",
        "registroRentri": "00753740158",
        "errorTextFull": "80040"
    },
]
